import Http from 'utils/http/index'
import store from 'store/index'

export const markAsRead = (id) => {
    return Http.put(`/notifications/${id}/read`)
               .then(response => {
                   store.dispatch('saveNotification', response.data)
                   return response.data
               })
}



// WEBPACK FOOTER //
// ./src/services/notifications.js